import { __assign, __awaiter, __generator } from "tslib";
import Vue from 'vue';
import TeamApply from '@/models/teamApply';
var m = {
  namespaced: true,
  state: function state() {
    return {
      monitorApply: null,
      monitorApplyStatus: null,
      teamApply: new TeamApply()
    };
  },
  mutations: {
    /**
     * 记录队长申请状态
     */
    setMonitorApplyStatus: function setMonitorApplyStatus(state, status) {
      state.monitorApplyStatus = status;
    },

    /**
     * 记录申请
     * @param {} apply 申请数据
     */
    setTeamApply: function setTeamApply(state, apply) {
      state.teamApply = apply;
    }
  },
  actions: {
    /**
     * 检查队长申请状态
     */
    checkMonitorApply: function checkMonitorApply(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor_apply/check', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setMonitorApplyStatus', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提交队长额外信息
     */
    submitMonitorInfo: function submitMonitorInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          predicatedMemberCount = _b.predicatedMemberCount,
          referrer = _b.referrer,
          referrerMobile = _b.referrerMobile;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/monitor_apply/create', {
                activity_id: activityId,
                predicted_member_count: predicatedMemberCount,
                referrer: referrer,
                referrer_mobile: referrerMobile
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 申请创建战队
     * @param {} data 数据
     */
    applyTeam: function applyTeam(context, _a) {
      var activityId = _a.activityId,
          apply = _a.apply;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/monitor/create_team', __assign({
                activity_id: activityId
              }, apply.toRaw()))];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;